import {Fragment} from "react";
import {Styled} from "../MainPage.styled";
import {ProductEntry, uniqueProducers} from "../../../lib/products";

type BrandMarqueeProps = {
    products: ProductEntry[]
}

/** Brands we always keep in stock, shown even before the remote config lands. */
const BASE_BRANDS = ['Pioneer', 'AlphaTheta', 'Technics', 'Allen & Heath', 'JBL', 'Shure', 'Yamaha', 'KRK']

const BrandMarquee = ({products}: BrandMarqueeProps) => {

    const brands = Array.from(new Set([...uniqueProducers(products), ...BASE_BRANDS]))

    const group = (
        <Styled.MarqueeGroup>
            {brands.map((brand) => (
                <Fragment key={brand}>
                    <Styled.MarqueeItem>{brand}</Styled.MarqueeItem>
                    <Styled.MarqueeDot/>
                </Fragment>
            ))}
        </Styled.MarqueeGroup>
    )

    return (
        <Styled.MarqueeSection aria-hidden={true}>
            <Styled.MarqueeTrack>
                {group}
                {group}
            </Styled.MarqueeTrack>
        </Styled.MarqueeSection>
    )
}

export default BrandMarquee
